import { Component } from '@angular/core';

@Component({
  selector: 'lib-user',
  imports: [],
  templateUrl: './user.html',
})
export class UserIcon {}
